module.exports = __webpack_public_path__ + "img/firstmanchester.5f46cc61.svg";